import React, { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import validator from 'validator';
import { useAuth } from '../../providers/auth_provider';

const AddFrequency = ({ fetchFrequencies, categories }) => {
    const { token } = useAuth();
    const [loading, setLoading] = useState(false);
    const frequencyAudioRef = useRef(null);
    const musicAudioRef = useRef(null);

    const [uploadProgress, setUploadProgress] = useState({
        frequency: 0
    });

    const [audioPreview, setAudioPreview] = useState({
        frequency: null,
        music: null
    });

    const [formData, setFormData] = useState({
        // title: '',
        description: '',
        soundtrack_volume: '50',
        frequency_volume: '50',
        category_id: '',
        status: 'active',
        subscription_type: '',
        frequency_audio: null,
        music_audio: null,
        thumbnail: null,
        free_start_time: '', // added for free subscription
        free_end_time: '', // added for free subscription
        no_of_days_for_free: '',
    });

    const [errors, setErrors] = useState({});

    const handleAudioPreview = (name, file) => {
        if (file) {
            const url = URL.createObjectURL(file);
            setAudioPreview(prev => ({
                ...prev,
                [name]: url
            }));

            // Reset progress when new file is selected
            setUploadProgress(prev => ({
                ...prev,
                [name]: 0
            }));
        }
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'frequency_audio' || name === 'music_audio') {
            setFormData(prev => ({
                ...prev,
                [name]: files[0],
            }));
            handleAudioPreview(name.split('_')[0], files[0]);
        } else if (name === 'thumbnail') {
            setFormData(prev => ({
                ...prev,
                [name]: files[0],
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value,
            }));

            // Update audio volume when slider changes
            if (name === 'frequency_volume' && frequencyAudioRef.current) {
                frequencyAudioRef.current.volume = parseInt(value) / 100;
            }
            if (name === 'soundtrack_volume' && musicAudioRef.current) {
                musicAudioRef.current.volume = parseInt(value) / 100;
            }
        }

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // if (validator.isEmpty(formData.title)) {
        //     newErrors.title = 'Title is required';
        // }
        if (!formData.frequency_audio) {
            newErrors.frequency_audio = 'Audio file is required';
        }
        if (validator.isEmpty(formData.category_id)) {
            newErrors.category_id = 'Category is required';
        }
        if (validator.isEmpty(formData.subscription_type)) {
            newErrors.subscription_type = 'Select Subscription mode';
        }

        // If subscription type is 'free', validate the free start and end time
        if (formData.subscription_type === 'free') {
            // if (validator.isEmpty(formData.free_start_time)) {
            //     newErrors.free_start_time = 'Free start time is required';
            // }
            // if (validator.isEmpty(formData.free_end_time)) {
            //     newErrors.free_end_time = 'Free end time is required';
            // } else if (formData.free_end_time < formData.free_start_time) {
            //     newErrors.free_end_time = 'End time cannot be before start time';
            // }

            if (!formData.no_of_days_for_free || formData.no_of_days_for_free == 0) {
                newErrors.no_of_days_for_free = 'Free Time is required';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Please fix the errors in the form');
            return;
        }

        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/frequency/create`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(prev => ({
                        ...prev,
                        frequency: percentCompleted
                    }));
                }
            });

            fetchFrequencies();
            toast.success(response.data.message);
            document.getElementById('closeModal').click();
            setFormData({
                // title: '',
                description: '',
                soundtrack_volume: '50',
                frequency_volume: '50',
                category_id: '',
                status: 'active',
                subscription_type: '',
                frequency_audio: null,
                music_audio: null,
                thumbnail: null,
                free_start_time: '', // added for free subscription
                free_end_time: '', // added for free subscription
                no_of_days_for_free: '',
            });
            setAudioPreview({ frequency: null, music: null });
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    const renderProgressBar = (type) => {
        if (uploadProgress[type] > 0 && uploadProgress[type] < 100) {
            return (
                <div className="progress my-2" style={{ height: '20px' }}>
                    <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${uploadProgress[type]}%` }}
                        aria-valuenow={uploadProgress[type]}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        {uploadProgress[type]}%
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="offcanvas offcanvas-end w-50" tabIndex={-1} id="offcanvasAddFrequency" aria-labelledby="offcanvasAddFrequencyLabel">
            <div className="offcanvas-header border-bottom">
                <h5 id="offcanvasAddFrequencyLabel" className="offcanvas-title">
                    Add Frequency
                </h5>
                <button
                    type="button"
                    id="closeModal"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                />
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 h-100">
                <form className="add-new-user pt-0" id="addNewFrequencyForm" onSubmit={handleSubmit}>
                    <div className="form-floating form-floating-outline mb-5">
                        <select
                            name="category_id"
                            className={`form-select text-capitalize ${errors.category_id ? 'is-invalid' : ''}`}
                            value={formData.category_id}
                            onChange={handleChange}
                        >
                            <option>Select Category</option>
                            {categories?.map((cat) => (
                                <option key={cat.id} className="text-capitalize" value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                        <label>Category</label>
                        {errors.category_id && <div className="invalid-feedback">{errors.category_id}</div>}
                    </div>

                    {/* Frequency Audio Section */}
                    <div className="mb-5">
                        <div className="form-floating form-floating-outline mb-3">
                            <input
                                type="file"
                                className={`form-control ${errors.frequency_audio ? 'is-invalid' : ''}`}
                                name="frequency_audio"
                                accept="audio/*"
                                onChange={handleChange}
                            />
                            <label>Frequency Audio</label>
                            {errors.frequency_audio && <div className="invalid-feedback">{errors.frequency_audio}</div>}
                        </div>
                        {renderProgressBar('frequency')}
                        {audioPreview.frequency && (
                            <div className="audio-preview border rounded p-3 d-md-flex align-items-center justify-content-between gap-3">
                                <audio ref={frequencyAudioRef} src={audioPreview.frequency} controls controlsList="nodownload" className="mb-2" />
                                <div className='text-center'>
                                    <label className="form-label">Frequency Volume {formData.frequency_volume}%</label>
                                    <input
                                        type="range"
                                        className="form-range w-100"
                                        name="frequency_volume"
                                        min="0"
                                        max="100"
                                        value={formData.frequency_volume}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Music Audio Section */}
                    {/* <div className="mb-5">
                        <div className="form-floating form-floating-outline mb-3">
                            <input
                                type="file"
                                className={`form-control ${errors.music_audio ? 'is-invalid' : ''}`}
                                name="music_audio"
                                accept="audio/*"
                                onChange={handleChange}
                            />
                            <label>Music Audio</label>
                            {errors.music_audio && <div className="invalid-feedback">{errors.music_audio}</div>}
                        </div>
                        {audioPreview.music && (
                            <div className="audio-preview border rounded p-3">
                                <audio ref={musicAudioRef} src={audioPreview.music} controls controlsList="nodownload" className="w-50 mb-2" />
                                <label className="form-label d-block">Music Volume {formData.soundtrack_volume}%</label>
                                <input
                                    type="range"
                                    className="form-range w-25 d-block"
                                    name="soundtrack_volume"
                                    min="0"
                                    max="100"
                                    value={formData.soundtrack_volume}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                    </div> */}

                    {/* <div className="form-floating form-floating-outline mb-5">
                        <input
                            type="text"
                            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                        />
                        <label>Title</label>
                        {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                    </div> */}

                    <div className="form-floating form-floating-outline mb-5">
                        <select
                            className={`form-select ${errors.subscription_type ? 'is-invalid' : ''}`}
                            name="subscription_type"
                            value={formData.subscription_type}
                            onChange={handleChange}
                        >
                            <option value="">Select</option>
                            <option value="paid">Paid</option>
                            <option value="free">Free</option>
                        </select>
                        <label>Subscription Type</label>
                        {errors.subscription_type && <div className="invalid-feedback">{errors.subscription_type}</div>}
                    </div>

                    {formData.subscription_type === 'free' ? (
                        <div className="d-flex gap-5 mb-5">
                            <div className="form-floating form-floating-outline mb-5 w-100">

                                <select className={
                                    `form-select ${errors.no_of_days_for_free ? 'is-invalid' : ''}`}
                                    name="no_of_days_for_free"
                                    value={formData.no_of_days_for_free}
                                    onChange={handleChange}>
                                    <option value="">Select</option>
                                    {[...Array(31)].map((_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            {i + 1} Days
                                        </option>
                                    ))}
                                </select>
                                <label>No of Days For Free</label>
                                {errors.no_of_days_for_free && <div className="invalid-feedback">{errors.no_of_days_for_free}</div>}
                            </div>

                            {/* <div className="form-floating form-floating-outline w-100">
                                <input
                                    type="date"
                                    className={`form-control ${errors.free_start_time ? 'is-invalid' : ''}`}
                                    name="free_start_time"
                                    value={formData.free_start_time}
                                    onChange={handleChange}
                                    min={new Date().toISOString().split("T")[0]}
                                    required
                                />
                                <label>Free Start Time</label>
                                {errors.free_start_time && <div className="invalid-feedback">{errors.free_start_time}</div>}
                            </div>
                            <div className="form-floating form-floating-outline w-100">
                                <input
                                    type="date"
                                    className={`form-control ${errors.free_end_time ? 'is-invalid' : ''}`}
                                    name="free_end_time"
                                    value={formData.free_end_time}
                                    onChange={handleChange}
                                    min={formData.free_start_time || new Date().toISOString().split("T")[0]}
                                    required
                                />
                                <label>Free End Time</label>
                                {errors.free_end_time && <div className="invalid-feedback">{errors.free_end_time}</div>}
                            </div> */}
                        </div>
                    ) : null}

                    <div className="d-flex justify-content-end">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Adding...' : 'Add Frequency'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddFrequency;